import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { BenutzermanagementAPIService } from '../api/benutzermanagement/benutzermanagement-api.service';
import { map } from 'rxjs/operators';

export const krankenkassenUserGuard: CanActivateFn = (route, state) => {
  const KKREROUTE = '/versorgungsvertraege/krankenkassen-dashboard';

  return checkBGAndReroute(KKREROUTE, state);
};

export const hdrgKrankenkassenUserGuard: CanActivateFn = (route, state) => {
  const KKREROUTE = '/hdrg/krankenkassen-dashboard';

  return checkBGAndReroute(KKREROUTE, state);
};

function checkBGAndReroute(reroute: string, state: RouterStateSnapshot) {
  const benutzerService = inject(BenutzermanagementAPIService);
  const router = inject(Router);

  return benutzerService.getBenutzergruppe().pipe(
    map((exValue) => {
      if (!exValue) {
        return router.createUrlTree([reroute]);
      }
      if (
        ['Krankenkassen Benutzer', 'Krankenkassen Vertragspartner'].includes(
          exValue,
        )
      ) {
        if (state.url === reroute) {
          return true;
        }
        return router.createUrlTree([reroute]);
      }
      return true;
    }),
  );
}
